import classnames from "classnames";

import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CheckStepDef} from "@/lib/types/checks.ts";
import {TxnNetworkResult, TxnResult} from "@/lib/types/transaction.ts";
import {RCAStep} from "@/pages/alerting/components/details/rca/RCAStep.tsx";

import styles from "./RCACheckResults.module.css";

interface RCACheckResultsProps {
  results: TxnResult[];
  network: TxnNetworkResult[];
  stepsDef: CheckStepDef[];
  version?: string;
}
export const RCACheckResults = ({results, stepsDef, network, version}: RCACheckResultsProps) => {
  return (
    <UpErrorBoundary>
      <h5 className="mt-2">
        <strong>Check Results</strong>
      </h5>
      <ol className={classnames(styles.transactionStepResults, "list-unstyled border rounded mb-4")}>
        {results.map((r, idx) => (
          <RCAStep idx={idx} key={idx} result={r} network={network} stepsDef={stepsDef} version={version} />
        ))}
      </ol>
    </UpErrorBoundary>
  );
};
